import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { clsx } from 'clsx'

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: 'sm' | 'md'
}

const variantClasses: Record<Variant, string> = {
  primary: 'bg-accent text-[#06101d] hover:brightness-110',
  secondary: 'bg-panel-2 text-text border border-line hover:bg-line',
  danger: 'bg-danger text-white hover:brightness-110',
  ghost: 'bg-transparent text-[#ff7b8a] border border-[#5c2a33] hover:bg-[#5c2a3322]',
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', className, disabled, ...props }, ref) => (
    <button
      ref={ref}
      disabled={disabled}
      className={clsx(
        'rounded-lg font-bold transition disabled:cursor-wait disabled:opacity-50',
        size === 'md' ? 'px-3.5 py-2.5 text-sm' : 'px-2.5 py-1.5 text-xs',
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  ),
)
Button.displayName = 'Button'
